module.exports = __webpack_public_path__ + "img/@tmp_facility_list_03.2349bd80.jpg";